<template>
  <div class="recruitment-create">
    <page-header :title="pageTitle">
      <template #action>
        <v-btn
          :to="{ name: routerPath, params: { id: projectId } }"
          link
          color="button"
          class="fw-400"
        >
          BACK
        </v-btn>
      </template>
    </page-header>

    <div class="recruitment-create__details">
      <RecruitmentDetailsForm :submit-name="submitName" @submit="create"/>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import PageHeader from '@/components/PageHeader.vue';
import RecruitmentDetailsForm from '@/components/Recruitments/RecruitmentDetailsForm.vue';

export default {
  components: {
    PageHeader,
    RecruitmentDetailsForm,
  },

  props: {
    projectId: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      pageTitle: 'Create recruitment',
      submitName: 'Create Recruitment',
    };
  },

  computed: {
    routerPath() {
      return this.$store.state.auth.role === 'super_hr' ? 'hr-project-show' : 'project-show';
    },
  },

  methods: {
    ...mapActions('recruitment', [
      'createRecruitment',
    ]),

    create(recruitment) {
      this.createRecruitment({ projectId: this.projectId, data: recruitment })
        .then(() => {
          this.$router.push({
            name: this.routerPath,
            params: { id: this.$route.params.projectId },
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
